import React from 'react';
import MediaQuery from 'react-responsive';

import './Landing.css';
import LandingImage from '../../images/about/about-cover.png';

function LandingSection() {
  return (
    <div id="aboutLanding">
      <img src={LandingImage} alt="Voxar researchers working on computers" />
      <div id="aboutHeader">
        <h1>
          Where does so much
          <br />
          innovation come from?
        </h1>
        <p>
          We are an R&D laboratory
          <MediaQuery query="(min-width: 425px)">
            <br />
          </MediaQuery>
          {' '}
          with the mission of training people
          <MediaQuery query="(min-width: 425px)">
            <br />
          </MediaQuery>
          {' '}
          by expanding realities and experiences.
        </p>
      </div>
    </div>
  );
}

export default LandingSection;
